import { Space } from 'antd'
import { Button } from '@/components/ui'
import { ReactNode } from 'react'

interface FixedBottomActionsProps {
  onCancel?: () => void
  onSubmit?: () => void
  cancelText?: string
  submitText?: string
  submitLoading?: boolean
  submitDisabled?: boolean
  leftActions?: ReactNode
  rightActions?: ReactNode
  className?: string
}

const FixedBottomActions = ({
  onCancel,
  onSubmit,
  cancelText = 'Cancel',
  submitText = 'Save Changes',
  submitLoading = false,
  submitDisabled = false,
  leftActions,
  rightActions,
  className = '',
}: FixedBottomActionsProps) => {
  return (
    <div
      className={`fixed bottom-0 left-64 right-0 z-50 flex items-center justify-between border-t border-gray-200 bg-white px-6 py-4 shadow-[0px_-2px_8px_0px_rgba(0,0,0,0.08)] ${className}`}
    >
      <div>
        {leftActions || (
          <Button variant="secondary" onClick={onCancel}>
            {cancelText}
          </Button>
        )}
      </div>
      <div>
        {rightActions || (
          <Space>
            <Button
              variant="primary"
              onClick={onSubmit}
              loading={submitLoading}
              disabled={submitDisabled}
            >
              {submitText}
            </Button>
          </Space>
        )}
      </div>
    </div>
  )
}

export default FixedBottomActions
